import React from "react";

function Screen(props) {
  const { style } = props;
  let _style = style ?? "flex-grow";
  return <div className={_style}>{props.children}</div>;
}

export default Screen;
